import api, { unwrap } from '../client';

// Base costing hypothétique des charges indirectes — un montant annuel par
// tenant × année, source du CCR/markup TDABC. Découplée du phasing cash de
// Planning (Indirect cost). Route : /api/tdabc/hypothetical-indirect/{tid}?year=
//
// GET  → { tenant_id, year, amount, notes, exists }
// PUT  → upsert { amount, notes }

export const getHypotheticalIndirect = (tid, year) =>
  unwrap(api.get(`/tdabc/hypothetical-indirect/${tid}`, { params: { year } }));

export const upsertHypotheticalIndirect = (tid, year, amount, notes = null) =>
  unwrap(api.put(`/tdabc/hypothetical-indirect/${tid}?year=${year}`, { amount, notes }));
